import { createContext, Dispatch, SetStateAction } from "react";

interface UserContextType {
  user: any;
  setUser: Dispatch<SetStateAction<any>>;
}

const UserContext = createContext<UserContextType | null>(null);

export default UserContext;
